import { Component, Input, ViewChild } from '@angular/core';
import { compareNumberOrString, isNilty } from '../../../../../core/utils.service';
import { SimplePublication } from '../../../../../models/product-details-model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-active-publications-table',
  templateUrl: './active-publications-table.component.html',
  styleUrls: ['./active-publications-table.component.css'],
})
export class ActivePublicationsTableComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() set publications(values: SimplePublication[]) {
    if (!isNilty(values)) {
      this.dataSource = new MatTableDataSource(values);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  dataSource: MatTableDataSource<SimplePublication>;
  displayedColumns = ['vendor', 'country', 'updatedAt', 'amazonPrice'];

  constructor() {}

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'vendor':
          return compareNumberOrString(a.vendor.code, b.vendor.code, isAsc);
        case 'country':
          return compareNumberOrString(a.vendor.country, b.vendor.country, isAsc);
        default:
          return compareNumberOrString(a[sort.active], b[sort.active], isAsc);
      }
    });
  }
}
